import { useMemo } from 'react'

import {
  GetMostUsedAIChatTopicsInput,
  GetMostUsedAIChatTopicsQuery,
  GetMostUsedAIChatTopicsQueryVariables,
} from 'types/graphql'

import { QueryKey, useQuery } from 'src/utils/queryClient'

const GetMostUsedAIChatTopicsQueryDocument = gql`
  query GetMostUsedAIChatTopicsQuery($input: GetMostUsedAIChatTopicsInput!) {
    getMostUsedAIChatTopics(input: $input) {
      results {
        count
        aiChatTopic {
          id
          topicName
        }
      }
      percentAIChatSessionsCoveredByMostUsedAIChatTopics
    }
  }
`

export const useGetMostUsedAIChatTopicsQuery = (input: GetMostUsedAIChatTopicsInput) => {
  const { data, ...rest } = useQuery<
    GetMostUsedAIChatTopicsQuery,
    GetMostUsedAIChatTopicsQueryVariables
  >({
    queryDocument: GetMostUsedAIChatTopicsQueryDocument,
    queryKey: [QueryKey.AIMostUsedChatTopics, input],
    variables: { input },
    enabled: !!input.organizationId && !!input.startDate && !!input.endDate,
  })

  const results = useMemo(() => {
    return data?.getMostUsedAIChatTopics?.results ?? []
  }, [data])

  const percentCovered = useMemo(() => {
    return data?.getMostUsedAIChatTopics?.percentAIChatSessionsCoveredByMostUsedAIChatTopics ?? 0
  }, [data])

  return {
    ...rest,
    results,
    percentCovered,
  }
}
